import React from "react";
import * as Mui from "@mui/material";
import { Check } from "@mui/icons-material";
import {
  designColors,
    designType,
  designWeights,
} from "services/constants/designTokens";

// Step indicator for the Pay Inputs wizards (e.g. Shift Earnings' Import
// and Change Payroll Cycle). Each step gets an equal-width column with its number on
// top and the label centred underneath, free to wrap, so long labels never
// push the row wider than a side panel. Done steps show a check, the current
// step gets a teal ring, and a line joins the circles.
const CIRCLE = 28;

export const WizardStepper = ({ steps, step }) => (
  <Mui.Box
    component="ol"
    sx={{
      display: "grid",
      gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))`,
      // Keeps the steps grouped when the wizard opens full width (Import).
      maxWidth: 720,
      mx: "auto",
      my: 0,
      p: 0,
      listStyle: "none",
    }}
  >
    {steps.map((label, index) => {
      const done = index < step;
      const active = index === step;
      const lineSx = (reached) => ({
        position: "absolute",
        top: CIRCLE / 2,
        height: "2px",
        backgroundColor: reached ? designColors.teal : designColors.slate300,
      });
      return (
        <Mui.Box
          component="li"
          key={label}
          aria-current={active ? "step" : undefined}
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.75,
            px: 0.5,
            minWidth: 0,
          }}
        >
          {/* Line halves to the previous and next circle. */}
          {index > 0 ? (
            <Mui.Box sx={{ ...lineSx(done || active), left: 0, right: `calc(50% + ${CIRCLE / 2 + 4}px)` }} />
          ) : null}
          {index < steps.length - 1 ? (
            <Mui.Box sx={{ ...lineSx(done), right: 0, left: `calc(50% + ${CIRCLE / 2 + 4}px)` }} />
          ) : null}
          <Mui.Box
            sx={{
              position: "relative",
              width: CIRCLE,
              height: CIRCLE,
              flexShrink: 0,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: designWeights.semibold,
              backgroundColor: done || active ? designColors.teal : designColors.white,
              color: done || active ? designColors.white : designColors.slate600,
              border: done || active ? "none" : `1px solid ${designColors.slate300}`,
              boxShadow: active ? `0 0 0 4px ${designColors.tealTint}` : "none",
            }}
          >
            {done ? <Check sx={{ fontSize: 16 }} /> : index + 1}
          </Mui.Box>
          <Mui.Typography
            sx={{
              ...designType.captionText,
              fontSize: 13,
              lineHeight: 1.35,
              textAlign: "center",
              overflowWrap: "anywhere",
              fontWeight: active ? designWeights.semibold : designWeights.medium,
              color: active ? designColors.tealDark : done ? designColors.slate800 : designColors.slate600,
            }}
          >
            {label}
          </Mui.Typography>
        </Mui.Box>
      );
    })}
  </Mui.Box>
);
